import { gql } from '@apollo/client';

export const EnterpriseLogin = gql`
  mutation EnterpriseLogin($email: Email!, $password: String!) {
    enterpriseLogin(email: $email, password: $password) {
      accessToken {
        token
        expiresIn
      }
      enterpriseClient {
        email
        enterprise {
          accentColor
          address2
          address1
          createdBy
          id
          name
          primaryColor
          secondaryColor
          status
          url
        }
        firstName
        id
        inviteStatus
        lastName
        lastSeen
        phoneNumber
        role
        status
        taxId
        type
      }
      mfaToken {
        expiresIn
        token
      }
    }
  }
`;
export const UpdateEnterpriseStatus = gql`
  mutation UpdateStatusByEnterpriseId(
    $updateStatusByEnterpriseIdId: ID!
    $input: EnterpriseStatus!
  ) {
    updateStatusByEnterpriseId(
      id: $updateStatusByEnterpriseIdId
      input: $input
    ) {
      address1
      address2
      createdOn
      id
      logoId
      name
      status
      url
      domain
      createdBy
      accentColor
    }
  }
`;

export const UpsertEnterpriseLogo = gql`
  mutation UpsertEnterpriseLogo($upsertEnterpriseLogoId: ID) {
    upsertEnterpriseLogo(id: $upsertEnterpriseLogoId) {
      fileName
      id
      presignedURL
      bucket
    }
  }
`;

export const CreateEnterprise = gql`
  mutation CreateEnterprise($input: EnterpriseCreationInput!) {
    createEnterprise(input: $input) {
      accentColor
      address1
      address2
      id
      name
      primaryColor
      status
      secondaryColor
      url
      createdBy
      createdOn
    }
  }
`;

export const InviteEnterpriseClient = gql`
  mutation InviteEnterpriseClient(
    $enterpriseId: ID!
    $input: InviteEnterpriseClientInput!
  ) {
    inviteEnterpriseClient(enterpriseId: $enterpriseId, input: $input) {
      email
      firstName
      id
      lastName
      phoneNumber
      role
      enterprise {
        id
        logoId
        name
        status
        address1
        address2
      }
    }
  }
`;
export const UpdateEnterpriseClientRoleById = gql`
  mutation UpdateEnterpriseClientRoleById(
    $updateEnterpriseClientRoleByIdId: ID!
    $input: EnterpriseClientRole!
  ) {
    updateEnterpriseClientRoleById(
      id: $updateEnterpriseClientRoleByIdId
      input: $input
    ) {
      email
      firstName
      id
      inviteStatus
      lastName
      phoneNumber
      role
      status
    }
  }
`;

export const UpdateEnterprise = gql`
  mutation UpdateEnterprise(
    $enterpriseId: ID!
    $enterpriseName: String!
    $Url: String!
    $Address1: String!
    $Address2: String!
    $PrimaryColor: String!
    $SecondaryColor: String!
    $AccentColor: String!
  ) {
    updateNameByEnterpriseId(id: $enterpriseId, input: $enterpriseName) {
      name
    }
    updateUrlByEnterpriseId(id: $enterpriseId, input: $Url) {
      url
    }
    updateAddress1ByEnterpriseId(id: $enterpriseId, input: $Address1) {
      address1
    }
    updateAddress2ByEnterpriseId(id: $enterpriseId, input: $Address2) {
      address2
    }
    updatePrimaryColorByEnterpriseId(id: $enterpriseId, input: $PrimaryColor) {
      primaryColor
    }
    updateSecondaryColorByEnterpriseId(
      id: $enterpriseId
      input: $SecondaryColor
    ) {
      secondaryColor
    }
    updateAccentColorByEnterpriseId(id: $enterpriseId, input: $AccentColor) {
      accentColor
    }
  }
`;

export const UpdateEnterpriseClient = gql`
  mutation UpdateEnterpriseClient(
    $enterpriseClientID: ID!
    $firstName: String!
    $LastName: String!
    $Role: EnterpriseClientRole!
    $Status: EnterpriseClientStatus!
    $Tax: String!
    $Type: String!
  ) {
    updateEnterpriseClientFirstNameById(
      id: $enterpriseClientID
      input: $firstName
    ) {
      firstName
    }
    updateEnterpriseClientLastNameById(
      id: $enterpriseClientID
      input: $LastName
    ) {
      lastName
    }
    updateEnterpriseClientRoleById(id: $enterpriseClientID, input: $Role) {
      role
    }
    updateEnterpriseClientStatusById(id: $enterpriseClientID, input: $Status) {
      status
    }
    updateEnterpriseClientTaxIdById(id: $enterpriseClientID, input: $Tax) {
      taxId
    }
    updateEnterpriseClientTypeById(id: $enterpriseClientID, input: $Type) {
      type
    }
  }
`;

export const CreateEnterpriseEmployeeFile = gql`
  mutation CreateEnterpriseEmployeeFile($enterpriseId: ID!) {
    createEnterpriseEmployeeFile(enterpriseId: $enterpriseId) {
      bucket
      fileName
      id
      presignedURL
    }
  }
`;

export const CreateEnterpriseEmployees = gql`
  mutation CreateEnterpriseEmployees(
    $fileId: ID!
    $mappings: EnterpriseEmployeeMappingsInput!
  ) {
    createEnterpriseEmployees(fileId: $fileId, mappings: $mappings) {
      errorRecords {
        message
        row
      }
      file {
        id
        presignedURL
        fileName
      }
      id
      status
      uploadedEmployeeStat {
        duplicate
        error
        modified
        new
        total
      }
    }
  }
`;

export const RegisterEnterpriseClient = gql`
  mutation RegisterEnterpriseClient(
    $input: RegisterEnterpriseClientInput!
    $enterpriseId: ID!
    $enterpriseClientId: ID
  ) {
    registerEnterpriseClient(
      input: $input
      enterpriseId: $enterpriseId
      enterpriseClientId: $enterpriseClientId
    ) {
      email
      enterprise {
        enterpriseLogo {
          presignedURL
        }
        id
        name
        status
        url
      }
    }
  }
`;

export const UpdateEnterpriseClientPasswordById = gql`
  mutation UpdateEnterpriseClientPasswordById(
    $updateEnterpriseClientPasswordByIdId: ID!
    $currentPassword: String!
    $newPassword: String!
  ) {
    updateEnterpriseClientPasswordById(
      id: $updateEnterpriseClientPasswordByIdId
      currentPassword: $currentPassword
      newPassword: $newPassword
    ) {
      accessToken {
        token
      }
      enterpriseClient {
        firstName
        lastName
        role
        status
        enterprise {
          name
          url
          address1
          address2
        }
      }
    }
  }
`;

export const ResetEnterpriseClientPasswordById = gql`
  mutation ResetEnterpriseClientPasswordById(
    $resetEnterpriseClientPasswordByIdId: ID!
  ) {
    resetEnterpriseClientPasswordById(
      id: $resetEnterpriseClientPasswordByIdId
    ) {
      message
    }
  }
`;

export const UpdateEnterpriseClientBySettingPage = gql`
  mutation UpdateEnterpriseClient(
    $enterpriseClientID: ID!
    $firstName: String!
    $LastName: String!
    $emailNotificationInput: Boolean!
    $textNotificationInput: Boolean!
  ) {
    updateEnterpriseClientFirstNameById(
      id: $enterpriseClientID
      input: $firstName
    ) {
      firstName
    }
    updateEnterpriseClientLastNameById(
      id: $enterpriseClientID
      input: $LastName
    ) {
      lastName
    }
    updateEnterpriseClientEmailNotificationById(
      id: $enterpriseClientID
      input: $emailNotificationInput
    ) {
      enterprise {
        id
        name
        status
      }
    }
    updateEnterpriseClientTextNotificationById(
      id: $enterpriseClientID
      input: $textNotificationInput
    ) {
      enterprise {
        id
        name
        status
      }
    }
  }
`;

export const SetEnterpriseClientPasswordByReset = gql`
  mutation SetEnterpriseClientPasswordByReset(
    $enterpriseClientId: ID!
    $newPassword: String!
  ) {
    setEnterpriseClientPasswordByReset(
      enterpriseClientId: $enterpriseClientId
      newPassword: $newPassword
    ) {
      message
    }
  }
`;

export const SendAppInviteByEmployeesId = gql`
  mutation SendAppInviteByEmployeesId($enterpriseEmployeeIds: [ID!]!) {
    sendAppInviteByEmployeesId(enterpriseEmployeeIds: $enterpriseEmployeeIds) {
      firstName
      lastName
      email
      id
    }
  }
`;


export const UpdateEmployee = gql`
  mutation UpdateEmployee(
    $updateEnterpriseEmployeeId: ID!
    $firstName: String!
    $lastName: String!
    $phoneNumber: PhoneNumber!
    $email: Email!
  ) {
    updateEnterpriseEmployeeFirstNameById(
      id: $updateEnterpriseEmployeeId
      input: $firstName
    ) {
      firstName
    }
    updateEnterpriseEmployeeLastNameById(
      id: $updateEnterpriseEmployeeId
      input: $lastName
    ) {
      lastName
    }
    updateEnterpriseEmployeePhoneById(id: $updateEnterpriseEmployeeId, input: $phoneNumber) {
      phoneNumber
    }
    updateEnterpriseEmployeeEmailById(id: $updateEnterpriseEmployeeId, input: $email) {
      email
    }
  }
`;

export const UpdateEnterpriseEmployeeUserStatus =gql`
mutation UpdateEnterpriseEmployeeUserStatusById($input: [EnterpriseEmployeeStatusInput!]!) {
  updateEnterpriseEmployeeUserStatusById(input: $input) {
    status
  }
}
`

export const ResetEnterpriseClientPasswordByEmail = gql`
mutation ResetEnterpriseClientPasswordByEmail($email: String!) {
  resetEnterpriseClientPasswordByEmail(email: $email) {
    message
  }
}
`